import { Rectangle } from '@thive/fddm-types';
import { MathUtils, Vector2, Vector3 } from 'three';

export const childPosition = (
  childRectangle: Rectangle,
  z: number,
  parentRectangle: Rectangle,
): Vector3 =>
  new Vector3(
    childRectangle.centerX * Math.cos(parentRectangle.angle) * 1000 -
      childRectangle.centerY * Math.sin(parentRectangle.angle) * 1000,
    childRectangle.centerX * Math.sin(parentRectangle.angle) * 1000 +
      childRectangle.centerY * Math.cos(parentRectangle.angle) * 1000,
    z,
  ).sub(
    new Vector3(
      parentRectangle.centerX * Math.cos(parentRectangle.angle) * 1000 -
        parentRectangle.centerY * Math.sin(parentRectangle.angle) * 1000,
      parentRectangle.centerX * Math.sin(parentRectangle.angle) * 1000 +
        parentRectangle.centerY * Math.cos(parentRectangle.angle) * 1000,
      0,
    ),
  );

export const childRotation = (childRectangle: Rectangle, parentRectangle: Rectangle): Vector3 =>
  new Vector3(0, 0, MathUtils.radToDeg(childRectangle.angle)).add(
    new Vector3(0, 0, MathUtils.radToDeg(parentRectangle.angle)),
  );

export const getPoseIdsFromPois = (poiIds: string[]): string[] =>
  poiIds.map((poiId) => [`${poiId}-pose`]).flat();

export const createPoseBackgroundPoints = (
  n: number,
  startAngle: number,
  endAngle: number,
): Vector2[] => {
  const angleDelta = Math.PI * 2 - (Math.PI - endAngle * 2);
  const angles = new Array(n).fill(null).map((_, i) => startAngle + (i * angleDelta) / (n - 1));
  return angles.map((angle) => new Vector2(Math.cos(angle), Math.sin(angle)).multiplyScalar(100));
};

export const createPoseNeedlePoints = (startAngle: number, endAngle: number) => [
  new Vector2(Math.cos(startAngle), Math.sin(startAngle)).multiplyScalar(100),
  new Vector2(Math.cos(Math.PI / 2), Math.sin(Math.PI / 2)).multiplyScalar(300),
  new Vector2(Math.cos(endAngle), Math.sin(endAngle)).multiplyScalar(100),
  new Vector2(0, -1).multiplyScalar(0),
];

export const getGroupBorderId = (groupId: string) => `${groupId}-border`;
